import React, { useState, useEffect, useCallback } from "react";
import { HERO_SLIDES } from "../data/mock";

const Hero = () => {
  const [idx, setIdx] = useState(0);

  const go = useCallback((i) => setIdx(i), []);

  useEffect(() => {
    // Prima slide più lunga per dare tempo di leggere il claim,
    // le successive con timing standard.
    const delay = idx === 0 ? 9000 : 6000;
    const t = setTimeout(() => {
      setIdx((p) => (p + 1) % HERO_SLIDES.length);
    }, delay);
    return () => clearTimeout(t);
  }, [idx]);

  return (
    <section id="top" className="relative h-screen w-full overflow-hidden bg-black">
      {HERO_SLIDES.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-[1400ms] ease-out ${
            i === idx ? "opacity-100" : "opacity-0"
          }`}
        >
          <div
            className="absolute inset-0 bg-cover bg-center scale-105"
            style={{
              backgroundImage: `url(${s.image})`,
              animation: i === idx ? "slowZoom 7s ease-out forwards" : "none",
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/30 to-black" />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />
        </div>
      ))}

      {/* Centered text */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-6 text-center">
        <p className="text-[10px] md:text-xs tracking-[0.6em] uppercase text-arabell-gold mb-6">
          Arabell Group
        </p>
        <h1 className="font-display text-5xl md:text-7xl lg:text-8xl tracking-[0.12em] text-white uppercase mb-8 leading-none">
          {HERO_SLIDES[idx].title}
        </h1>
        <div className="w-16 h-px bg-arabell-gold mb-6" />
        <p className="text-xs md:text-sm tracking-[0.45em] uppercase text-white/70 max-w-xl">
          {HERO_SLIDES[idx].subtitle}
        </p>
      </div>

      {/* Dots */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3">
        {HERO_SLIDES.map((_, i) => (
          <button
            key={i}
            onClick={() => go(i)}
            aria-label={`Slide ${i + 1}`}
            className={`h-1.5 rounded-full transition-all duration-500 ${
              i === idx ? "w-10 bg-arabell-gold" : "w-1.5 bg-white/40 hover:bg-white/70"
            }`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
